import { Copy } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { toast } from '@/components/ui/toast'
import { Tooltip } from '@/components/ui/tooltip'
import { toErrorMessage } from '@/helpers/logger'

interface CopyButtonProps {
  value: string
  /** What is being copied, for the label and the toast ("API key"). */
  label: string
}

/** Copies a value to the clipboard and confirms with a toast. */
export function CopyButton({ value, label }: CopyButtonProps) {
  async function copy(): Promise<void> {
    try {
      await navigator.clipboard.writeText(value)
      toast.success(`${label} copied`)
    } catch (error) {
      toast.error(`Could not copy: ${toErrorMessage(error)}`)
    }
  }

  return (
    <Tooltip content={`Copy ${label.toLowerCase()}`}>
      <Button type="button" variant="ghost" size="icon-sm" aria-label={`Copy ${label.toLowerCase()}`} onClick={() => void copy()}>
        <Copy />
      </Button>
    </Tooltip>
  )
}
